import { StylesProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import AppTemplate from './template/appTemplate'
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Home from './Home'
import FAQPage from './faqs'
import DemosPage from './demos'
import AboutUsPage from './aboutUs'
import OfferingsPage from './offerings'
import PartnersPage from './partners'
import ContactUsPage from './contactUs'

import './assets/sheets/main.scss'

function App() {

  return (

    <StylesProvider injectFirst >

    <CssBaseline />
      <AppTemplate>
      <BrowserRouter>
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/faqs' element={<FAQPage />} />
              <Route path='/demos'  element={<DemosPage />}  />
              <Route path='/aboutUs' element={<AboutUsPage />} />
              <Route path='/offerings' element={<OfferingsPage />} />
              <Route path='/partners' element={<PartnersPage />} />
              <Route path='/contactUs' element={<ContactUsPage />} />
            </Routes>
        </BrowserRouter>  
      </AppTemplate>
    </StylesProvider>

  )
}

export default App
